<!-- Trigger button (always visible in upload card) -->
<div class="camera-trigger" (click)="openModal()">
  <div class="camera-icon-wrap">
    <svg width="26" height="26" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M23 19C23 19.5304 22.7893 20.0391 22.4142 20.4142C22.0391 20.7893 21.5304 21 21 21H3C2.46957 21 1.96086 20.7893 1.58579 20.4142C1.21071 20.0391 1 19.5304 1 19V8C1 7.46957 1.21071 6.96086 1.58579 6.58579C1.96086 6.21071 2.46957 6 3 6H7L9 3H15L17 6H21C21.5304 6 22.0391 6.21071 22.4142 6.58579C22.7893 6.96086 23 7.46957 23 8V19Z"
        stroke="#6B7280" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/>
      <path d="M12 17C14.2091 17 16 15.2091 16 13C16 10.7909 14.2091 9 12 9C9.79086 9 8 10.7909 8 13C8 15.2091 9.79086 17 12 17Z"
        stroke="#6B7280" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/>
    </svg>
  </div>
  <!-- //צלם מסמך -->
  <span class="camera-label">{{ 'documentCamera.triggerLabel' | translate }}</span>
</div>

<!-- Modal backdrop -->
<div *ngIf="isModalOpen" class="modal-backdrop" (click)="closeModal()"></div>

<!-- Modal panel -->
<div *ngIf="isModalOpen" class="modal-panel" (click)="$event.stopPropagation()">

  <!-- Header -->
  <div class="modal-header">
    <span class="modal-title">{{ 'documentCamera.modalTitle' | translate }}</span>
    <button type="button" class="btn-icon" (click)="closeModal()">
      <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" width="20" height="20">
        <path d="M18 6L6 18M6 6L18 18" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>
      </svg>
    </button>
  </div>

  <!-- Video (always in DOM) -->
  <div class="modal-body">
    <video #video class="camera-video" [class.camera-video--hidden]="!isCameraOpen()" autoplay muted playsinline></video>
    <canvas #canvas hidden></canvas>
    <button
      *ngIf="isCameraOpen()"
      type="button"
      class="btn-switch-camera"
      [attr.aria-label]="'documentCamera.switchCamera' | translate"
      [title]="'documentCamera.switchCamera' | translate"
      (click)="switchCamera()"
    >
      <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" width="20" height="20">
        <path d="M23 4V10H17" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
        <path d="M1 20V14H7" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
        <path d="M3.51 9.00003C4.01717 7.56656 4.87913 6.2854 6.01547 5.27543C7.1518 4.26546 8.52547 3.55984 10.0083 3.22427C11.4911 2.8887 13.0348 2.93436 14.4952 3.35685C15.9556 3.77935 17.2853 4.56471 18.36 5.64003L23 10M1 14L5.64 18.36C6.71475 19.4353 8.04437 20.2207 9.50481 20.6432C10.9652 21.0657 12.5089 21.1113 13.9917 20.7758C15.4745 20.4402 16.8482 19.7346 17.9845 18.7246C19.1209 17.7146 19.9828 16.4335 20.49 15"
          stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
      </svg>
    </button>
    <!-- Preview -->
    <div *ngIf="capturedImageUrl() && !isCameraOpen()" class="preview-container">
      <img [src]="capturedImageUrl()" class="preview-image" />
    </div>
  </div>

  <!-- Footer actions -->
  <div class="modal-footer">

    <!-- Live camera actions -->
    <ng-container *ngIf="isCameraOpen()">
      <button type="button" class="btn btn-capture" (click)="captureDocument()">
        <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" width="20" height="20">
          <circle cx="12" cy="12" r="10" stroke="currentColor" stroke-width="1.8"/>
          <circle cx="12" cy="12" r="5" fill="currentColor"/>
        </svg>
        {{ 'documentCamera.capture' | translate }}
      </button>
    </ng-container>

    <!-- Preview actions -->
    <ng-container *ngIf="capturedImageUrl() && !isCameraOpen()">
      <button type="button" class="btn btn-secondary" (click)="openCamera()">
        <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" width="18" height="18">
          <path d="M1 4V10H7" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
          <path d="M3.51 15C4.15839 16.8404 5.38734 18.4202 7.01166 19.5014C8.63598 20.5826 10.5677 21.1066 12.5157 20.9945C14.4637 20.8824 16.3226 20.1402 17.8121 18.8798C19.3017 17.6193 20.3413 15.909 20.7742 14.0064C21.2072 12.1037 21.0101 10.112 20.2126 8.33111C19.4152 6.55025 18.0605 5.07624 16.3528 4.13271C14.6451 3.18919 12.6769 2.82672 10.7447 3.09919C8.81245 3.37166 7.02091 4.26495 5.64 5.64L1 10"
            stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
        {{ 'documentCamera.retake' | translate }}
      </button>
      <button type="button" class="btn btn-capture" (click)="addCapturedFileToUpload()">
        <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" width="18" height="18">
          <path d="M20 6L9 17L4 12" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
        {{ 'documentCamera.addToFiles' | translate }}
      </button>
    </ng-container>

  </div>
</div>
